import Link from 'next/link'

export function LoginFooter() {
  return (
    <footer className="text-checkout-xs text-checkout-bk-op50 flex py-8 font-normal">
      <div className="flex flex-col gap-4 md:flex-row">
        <span>© {new Date().getFullYear()} Formación Ninja</span>
        <div className="flex flex-col gap-4 underline md:flex-row">
          <Link
            className="hover:text-[#5368E5]"
            href={
              'https://formacion.ninja/aviso-legal/condiciones-de-contratacion'
            }
            target={'_blank'}>
            Condiciones de contratación
          </Link>
          <Link
            className="hover:text-[#5368E5]"
            href={'https://formacion.ninja/aviso-legal/politica-de-cookies'}
            target={'_blank'}>
            Cookies
          </Link>
          <Link
            className="hover:text-[#5368E5]"
            href={'https://formacion.ninja/aviso-legal/aviso-legal'}
            target={'_blank'}>
            Aviso legal
          </Link>
          <Link
            className="hover:text-[#5368E5]"
            href={'https://formacion.ninja/aviso-legal/politica-de-privacidad'}
            target={'_blank'}>
            Políticas de privacidad
          </Link>
        </div>
      </div>
    </footer>
  )
}
